import type { LayoutPresetProps } from './types';

const spacings = {
  xs: { spacing: 'xs' as const },
  s: { spacing: 's' as const },
  m: { spacing: 'm' as const },
  l: { spacing: 'l' as const },
  xl: { spacing: 'xl' as const },
};

export const presets = {
  ...spacings,
  'card-horizontal': {
    direction: 'row' as const,
    spacing: 'l' as const,
  },
  'card-vertical': {
    direction: 'column' as const,
    spacing: 'l' as const,
  },
  buttons: {
    align: 'center' as const,
    role: 'toolbar',
  },
  chips: {
    spacing: 'xs' as const,
    wrap: true as const,
  },
  'form-fields': {
    direction: 'column' as const,
    spacing: 'm' as const,
  },
  icons: {
    align: 'center' as const,
    direction: 'row' as const,
    spacing: 's' as const,
  },
  sections: {
    direction: 'column' as const,
    spacing: 'l' as const,
  },
  subsections: {
    direction: 'column' as const,
    spacing: 'm' as const,
  },
} as const satisfies Record<string, LayoutPresetProps>;

export type LayoutPresetKey = keyof typeof presets;
